import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetDeviceListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetDeviceListPagingAndFilterRequest: GetDeviceListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    columnChooser: undefined,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnFilters: []
}